module.exports = __webpack_public_path__ + "static/media/sale-icon.2d3b6fff.svg";